import React, { useMemo } from 'react'
import { Box, CustomSettingIcon } from '@usap/uicomponents'
import Label from './Label'
import Container from './Container'
import CustomAnchorContainer from './CustomAnchorContainer'
import DoesNotFitContainer from './DoesNotFitContainer'
import UniversalFitContainer from './UniversalFitContainer'
import CheckFitmentAnchorContainer from './CheckFitmentAnchorContainer'
import OverlaySpinner from '../OverlaySpinner'
import Avatar from '../Avatar'

export default function VehicleContainer({
  hideBorder,
  ongoingFitmentCall,
  isCard,
  lastLabelSize = 'medium',
  containerProps = {},
  avatarProps = {},
  lastLabelText = '',
  lastLabelContainerProps = {},
  isUniversal = false,
  isDoesNotFit = false,
  needFitmentChecking,
  isPdpRp1Enabled,
  dataTestId = null,
  ...rest
}) {
  const LabelComponent = useMemo(() => {
    if (isUniversal) return UniversalFitContainer
    if (isDoesNotFit) return DoesNotFitContainer
    if (needFitmentChecking) return CheckFitmentAnchorContainer
    return CustomAnchorContainer
  }, [isDoesNotFit, isUniversal, needFitmentChecking])

  const { specialPLAVehicleSelector, searchVehicleTrigger } = rest

  const cardClickObject = useMemo(() => {
    if (!specialPLAVehicleSelector && !searchVehicleTrigger) return {}
    return {
      onClick: searchVehicleTrigger,
    }
  }, [searchVehicleTrigger, specialPLAVehicleSelector]);

  return (
    <Container hideBorder={hideBorder} isPdpRp1Enabled={isPdpRp1Enabled} {...containerProps} data-testid={dataTestId}>
      <Box direction="row" style={{ position: 'relative' }}>
        <OverlaySpinner active={ongoingFitmentCall} />
        <Avatar
          background="#333333"
          Icon={CustomSettingIcon}
          IcoSize="18px"
          {...avatarProps}
        />
        {isCard ? (
          <Box
            alignSelf="center"
            pad={{ left: 'small' }}
            width="calc(100% - 34px)"
            {...cardClickObject}
            {...lastLabelContainerProps}
          >
            <Label size={lastLabelSize}>{lastLabelText}</Label>
          </Box>

        ) : (
          <LabelComponent width="calc(100% - 34px)" {...rest} isPdpRp1Enabled={isPdpRp1Enabled}/>
        )}
      </Box>
    </Container>
  )
}
